module.exports = __webpack_public_path__ + "img/avatar_2.d0f57d9a.jpg";